import React, { useState, useEffect } from "react";
import "../App.css";

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if the user has already accepted the cookies
    const accepted = localStorage.getItem("cookiesAccepted");
    if (!accepted) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    setShowBanner(false);
    localStorage.setItem("cookiesAccepted", "true");
  };

  return (
    showBanner && (
      <div className="bottom-bar-banner">
        <div className="bottom-bar-content">
          <p>
            This website uses cookies to enhance the user experience. By
            continuing, you agree to our{" "}
            <a href="/policy" target="_blank" className="bottom-bar-link">
              Privacy Policy
            </a>{" "}
            and{" "}
            <a href="/terms" target="_blank" className="bottom-bar-link">
              Terms and Conditions
            </a>.
          </p>
          <button className="bottom-bar-button" onClick={handleAccept}>
            Accept
          </button>
        </div>
      </div>
    )
  );
};

export default CookieBanner;
